export interface UserRegisterData {
  USER_REGISTER_ID: string;
  USER_REGISTER_TYPECODE: string;
  USER_REGISTER_COMPANY_NAME_TH: string | null;
  USER_REGISTER_COMPANY_NAME_EN: string | null;
  USER_REGISTER_POSITION_TH: string | null;
  USER_REGISTER_POSITION_EN: string | null;
  USER_REGISTER_WORKLOCATION: string | null;
  USER_REGISTER_WORKPHONE: string | null;
  USER_REGISTER_WORKPHONE_EXT: string | null;
  USER_REGISTER_USERNAME: string;
  USER_REGISTER_PASSWORD: string;
  USER_REGISTER_EMAIL: string;
  USER_REGISTER_PREFIX_TH: string;
  USER_REGISTER_PREFIX_EN: string;
  USER_REGISTER_FIRSTNAME_TH: string;
  USER_REGISTER_FIRSTNAME_EN: string;
  USER_REGISTER_LASTNAME_TH: string;
  USER_REGISTER_LASTNAME_EN: string;
  USER_REGISTER_IDCARD: string;
  USER_REGISTER_MOBILEPHONE: string;
  USER_REGISTER_OBJECTIVE: string;
  USER_REGISTER_STATUS: string;
  USER_REGISTER_DATE: string;
  USER_REGISTER_REASON: string;
  USER_REGISTER_START_DATE: string | null;
  USER_REGISTER_END_DATE: string | null;
  USER_REGISTER_APPROVE_STATUS: string | null;
}

/**
 * Get user registration data from localStorage
 * @returns UserRegisterData object or null if not found
 */
export const getUserRegisterData = (): UserRegisterData | null => {
  try {
    const userRegisterData = localStorage.getItem("userregister");
    if (!userRegisterData) {
      return null;
    }

    const parsedData = JSON.parse(userRegisterData);
    if (Array.isArray(parsedData) && parsedData.length > 0) {
      return parsedData[0] as UserRegisterData;
    }

    return null;
  } catch (error) {
    console.error("Error parsing user register data from localStorage:", error);
    return null;
  }
};

/**
 * Get user registration ID from localStorage
 * @returns User registration ID or "UNKNOWN" if not found
 */
export const getUserRegisterId = (): string => {
  const userData = getUserRegisterData();
  return userData?.USER_REGISTER_ID || "UNKNOWN";
};

/**
 * Get user email from localStorage
 * @returns User email or empty string if not found
 */
export const getUserEmail = (): string => {
  const userData = getUserRegisterData();
  return userData?.USER_REGISTER_EMAIL || "";
};

/**
 * Get user full name from localStorage
 * @param language Language preference ('th' or 'en')
 * @returns User full name or empty string if not found
 */
export const getUserFullName = (language: "th" | "en" = "th"): string => {
  const userData = getUserRegisterData();
  if (!userData) return "";

  if (language === "th") {
    const prefix = userData.USER_REGISTER_PREFIX_TH?.trim() || "";
    const firstName = userData.USER_REGISTER_FIRSTNAME_TH?.trim() || "";
    const lastName = userData.USER_REGISTER_LASTNAME_TH?.trim() || "";
    return `${prefix} ${firstName} ${lastName}`.trim();
  } else {
    const prefix = userData.USER_REGISTER_PREFIX_EN?.trim() || "";
    const firstName = userData.USER_REGISTER_FIRSTNAME_EN?.trim() || "";
    const lastName = userData.USER_REGISTER_LASTNAME_EN?.trim() || "";
    return `${prefix} ${firstName} ${lastName}`.trim();
  }
};
